import React from "react";
import { Search, X, ChevronDown } from "lucide-react";
import { optionsEstado } from "../../../../constantes/constantes";



function FitrosLocales({
    nameCedula, handleNameCedula, estadoSelected, handleEstadoSelected, handleSearchEstado, title,
    categorias, handleCategoriaSelected,
    categoriaSelected, handleSearchCategoria,
}) {



  

    return (
        <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200 mb-6">
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">

                {/* Buscar local */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Buscar local
                    </label>
                    <div className="relative flex items-center">
                        <Search size={16} className="absolute left-3 text-gray-400 pointer-events-none" />
                        <input
                            type="text"
                            value={nameCedula}
                            onChange={(e) => handleNameCedula(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            placeholder="Razón social, RUC o nombre de fantasía"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] py-2 pl-9 pr-9 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                        {nameCedula && (
                            <button
                                type="button"
                                onClick={() => handleNameCedula("")}
                                className="absolute right-3 text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <X size={15} />
                            </button>
                        )}
                    </div>
                </div>

                {/* Estado */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Estado
                    </label>
                    <div className="relative">
                        <select
                            value={estadoSelected?.value || ""}
                            onChange={(e) => {
                                const val = e.target.value;
                                handleSearchEstado(val);
                                handleEstadoSelected(optionsEstado.find((o) => o.value === val) || null);
                            }}
                            className="appearance-none w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 pr-8 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200 cursor-pointer"
                        >
                            <option value="">Todos</option>
                            {optionsEstado.map((option) => (
                                <option key={option.id} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                            <ChevronDown size={15} />
                        </span>
                    </div>
                </div>

                {/* Categorías */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Categoría
                    </label>
                    <div className="relative">
                        <select
                            value={categoriaSelected?.id || ""}
                            onChange={(e) => {
                                const val = e.target.value;
                                handleSearchCategoria(val);
                                handleCategoriaSelected(categorias.find((o) => String(o.id) === val) || null);
                            }}
                            className="appearance-none w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 pr-8 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200 cursor-pointer"
                        >
                            <option value="">Todas</option>
                            {categorias?.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.nombre}
                                </option>
                            ))}
                        </select>
                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                            <ChevronDown size={15} />
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default FitrosLocales;